module.exports = __webpack_public_path__ + "static/media/german-time-table-1.8c724120.JPG";